webpackJsonp([253844482878330],{

/***/ 1283:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-cb7552daa6da55e7c330.js